import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageTracking } from "hooks/usePageTracking";

export const WrongDevice = () => {
  usePageTracking({ name: "Error - view", properties: { type: "Wrong device" } });
  const { t } = useClientTranslation();

  return (
    <PageLayout title={t("error.wrong_device.header")}>
      <Text sizeVariant="md" mt={24} mx={24}>
        {t("error.wrong_device.instruction")}
      </Text>
      <Text sizeVariant="md" mt={8} mx={24}>
        {t("error.contact_us")}
      </Text>
    </PageLayout>
  );
};
